<template>
    <div>
        <video :src="src" controls style="max-width: 300px"></video>
    </div>
</template>

<script>
export default {
    props: ['src', 'anexo', 'eventId'],
}
</script>